export default __webpack_public_path__ + "static/media/Shopkeeper.c58b0dc80d073f7bb1b6056a89aed6e3.svg";